import React from 'react';
import Register from 'views/Meteorology/Agro/Register';
import AgroWrapper from 'components/RouteWrappers/Meteorology/Agro';
import waterBalanceSequentialRouter from './WaterBalanceSequentialRouter';
import waterBalanceCultureRouter from './WaterBalanceCultureRouter';
import cultureIndexRouter from './CultureIndexRouter';
import trackingForecastRouter from './TrackingForecastRouter';
import overviewRouter from './OverviewRouter';
import similarityRouter from './SimilarityRouter';

const agroRouter = {
  path: 'agro',
  element: <AgroWrapper />,
  children: [
    { path: 'register', element: <Register /> },
    waterBalanceSequentialRouter,
    waterBalanceCultureRouter,
    cultureIndexRouter,
    trackingForecastRouter,
    overviewRouter,
    similarityRouter,
  ],
};

export default agroRouter;
